var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCatalogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0312 1.00818H12V16.0004H0V1.00818H0.984375V0.000366211H1.98438V1.00818H4V0.000366211H5V1.00818H7.01562V0.000366211H8.01562V1.00818H10.0312V0.000366211H11.0312V1.00818ZM11 15.0004V2.00818H1V15.0004H11ZM9 4.00818V5.00818H3V4.00818H9ZM3 13.016V12.016H9V13.016H3ZM3 9.00818V8.00818H9V9.00818H3Z",
    fill: "#205493"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogs);
export default __webpack_public_path__ + "static/media/catalogs.fda2569a60e644c1e69497020b6d10b4.svg";
export { ForwardRef as ReactComponent };